import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../../features/layout/RequirePermission';
import { RolesPage } from '../../../features/admin/roles/RolesPage';

export const Route = createFileRoute('/_authed/admin/roles')({ component: Guarded });

function Guarded(): React.JSX.Element {
  return (
    <RequirePermission permission="roles.manage">
      <RolesPage />
    </RequirePermission>
  );
}
